import { Injectable } from '@angular/core';
// import * as moment from 'moment';
import moment, { DurationInputArg1, DurationInputArg2 } from 'moment';
import { WEEKDAYS_CONSTANT } from '@app/lib/b2b-constants/app-settings.constant';
import {DateModel} from "@app/models/client-models/date/date.model";

@Injectable({
  providedIn: 'root',
})
export class DateUtilService {
  constructor() {
    moment.updateLocale('en', {
      calendar: {
        lastDay: '[Yesterday]',
        sameDay: '[Today]',
        nextDay: '[Tomorrow]',
        lastWeek: '[Last] dddd',
        nextWeek: '[Next] dddd',
        sameElse: 'L',
      },
    });
  }

  static getTimezoneOffset(): string {
    return Intl.DateTimeFormat().resolvedOptions().timeZone;
  }

  // New functions starts
  getDisplayFormattedDate(date: Date): string {
    return moment(date).calendar(null, {
      // sameDay: '[Today]',
      // nextDay: '[Tomorrow]',
      // nextWeek: 'dddd',
      lastDay: '[Yesterday]',
      lastWeek: '[Last] dddd',
      // sameElse: 'DD/MM/YYYY',
      sameDay: 'ddd, [Today]',
      nextDay: 'ddd, [Tomorrow]',
      nextWeek: 'MMM DD, YYYY',
      sameElse: 'MMM DD, YYYY',
    });
  }

  getCalendarRange() {
    return {
      Today: [new Date(), new Date()],
      Yesterday: [
        this.subtractToDate(1, 'day', new Date()),
        this.subtractToDate(1, 'day', new Date()),
      ],
      'Last 7 Days': [this.subtractToDate(6, 'day', new Date()), new Date()],
      'Last 30 Days': [this.subtractToDate(29, 'day', new Date()), new Date()],
      'This Month': [
        this.startOf('month', new Date()),
        this.endOf('month', new Date()),
      ],
      'Last Month': [
        this.startOf('month', this.subtractToDate(1, 'month', new Date())),
        this.endOf('month', this.subtractToDate(1, 'month', new Date())),
      ],
    };
  }

  public createDateFromFormattedDate(
    date: Date | string,
    format: string,
  ): Date {
    return moment(date, format).toDate();
  }

  public createDateStringByFormat(
    date: string,
    dateFormat: string,
    requiredFormat: string,
  ): string {
    return moment(date, dateFormat).format(requiredFormat);
  }

  public getFormattedDate(date: Date, format: string): string {
    return moment(date).format(format);
  }

  public createDateAndTime(date: Date, time: string): Date {
    let dateString: string = moment(date).format('YYYY-MM-DD');
    dateString = dateString + ' ' + time;
    return moment(dateString, 'YYYY-MM-DD hh:mm a').toDate();
  }

  public addToDate(
    amount: DurationInputArg1,
    unit: DurationInputArg2,
    date: Date,
  ): Date {
    return moment(date).add(amount, unit).toDate();
  }

  public subtractToDate(
    amount: DurationInputArg1,
    unit: DurationInputArg2,
    date: Date,
  ): Date {
    return moment(date).subtract(amount, unit).toDate();
  }

  public startOf(unit: DurationInputArg2, date: Date): Date {
    return moment(date).startOf(unit).toDate();
  }

  public endOf(unit: DurationInputArg2, date: Date): Date {
    return moment(date).endOf(unit).toDate();
  }

  public diff(date1: Date, date2: Date, unit: DurationInputArg2): number {
    return moment(date1).diff(moment(date2), unit);
  }

  public constructListOfIntervals(
    start: Date,
    end: Date,
    interval: string,
  ): Date[] {
    const intervals: Date[] = [];
    const diffUnitOfTime: any = `${interval}s`;

    const diff: number = moment(end).diff(start, diffUnitOfTime);

    for (let i = 0; diff >= i; i++) {
      intervals.push(moment(start).toDate());
      start = moment(moment(start).add(1, diffUnitOfTime)).toDate();
    }
    return intervals;
  }

  public filterListBySelectedDays(
    dates: Date[],
    selectedDays: number[],
  ): Date[] {
    const finalDates: Date[] = [];
    for (const date of dates) {
      const day: string = this.getFormattedDate(date, 'ddd');
      const foundedItem: { display: string; value: number } =
        WEEKDAYS_CONSTANT.find(
          (item: { display: string; value: number }) =>
            selectedDays.includes(item?.value) && item.display === day,
        );
      if (foundedItem) {
        finalDates.push(date);
      } else {
      }
    }
    return finalDates;
  }



   isDatesWithinSameMonth(start: string, end: string): boolean {
    const startDate = moment(start, "YYYY-MM-DD", true);
    const endDate = moment(end, "YYYY-MM-DD", true);

    if (!startDate.isValid() || !endDate.isValid()) {
      return false;
    }
    return (
      startDate.month() === endDate.month() &&
      startDate.year() === endDate.year()
    );
  }

  isSameDay(
    compareDate: Date | string,
    format: string,
    date: Date | string | DateModel,
    compareDateFormat: string,
    // timeZone?: string,
  ): boolean {
    // if (!timeZone) {
    //   timeZone = 'Asia/Calcutta';
    // }
    const dateMoment: moment.Moment = moment(date as any, format);
    const compareMoment: moment.Moment = moment(
      compareDate as any,
      compareDateFormat,
    );
    return dateMoment.isSame(compareMoment, 'date');
  }


   formatDate(date: Date | DateModel | string, format: string): string {
    return moment(date).format(format);
  }


}
